import { Spacing, Text, Title } from '@vkontakte/vkui';
import coverImage from 'img/quota-landing/autoupload-cover-new.png';
import coverImageMobile from 'img/quota-landing/autoupload-cover-new-mobile.png';
import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { platform } from 'reactApp/appHelpers/configHelpers';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { sendDwh, sendXray } from 'reactApp/utils/ga';

import styles from './AutoUploadBuyDialog.css';

const sendRadar = (action: 'show' | 'click' | 'close') => {
    sendXray(['autoupload_buysucc', platform, action]);
    sendDwh({
        eventCategory: 'modal',
        action,
        dwhData: { name: 'unlimited_upload _success' },
    });
};

export const AutoUploadBuyDialog = memo<{ onClose?(): void }>(({ onClose }) => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);
    const scrollRef = useRef<HTMLDivElement>(null);

    const handleClose = useCallback(() => {
        sendRadar('close');
        onClose?.();
    }, [onClose]);

    const handleOk = useCallback(() => {
        sendRadar('click');
        onClose?.();
    }, [onClose]);

    useEffect(() => {
        sendRadar('show');
    }, []);

    const content = useMemo(() => {
        return (
            <div className={styles.content}>
                <Spacing size={12} />
                <Text className={styles.text}>Фото и видео из телефона загрузятся в Облако Mail, но место в нём не займут</Text>
                <Spacing size={24} />
            </div>
        );
    }, []);

    if (isMobile) {
        return (
            <MobileDialog
                id="autoupload-pay-succ-mob"
                onClose={handleClose}
                topmost
                closeOnDimmerClick
                scrollRef={scrollRef}
                mod="base"
                contextPadding="zero"
                isRebrandingQuotaLanding
            >
                <div ref={scrollRef} className={styles.rootMobile}>
                    <div className={styles.imageContainer}>
                        <img src={coverImageMobile} className={styles.image} alt="Автозагрузка без ограничений" />
                    </div>
                    <Spacing size={48} />
                    <Title level="1" className={styles.title}>
                        Автозагрузка
                        <br />
                        без&nbsp;ограничений — ваша
                    </Title>
                    <Spacing size={12} />
                    <Text className={styles.text}>
                        Фото и&nbsp;видео из&nbsp;телефона загрузятся в&nbsp;Облако&nbsp;Mail, но&nbsp;место в&nbsp;нём&nbsp;не&nbsp;займут
                    </Text>
                    <Spacing size={24} />
                    <div className={styles.buttonWrapper}>
                        <Button theme="vk" primary onClick={handleOk} sizeMode={ButtonSizeMode.big}>
                            Хорошо
                        </Button>
                    </div>
                </div>
            </MobileDialog>
        );
    }

    return (
        <WhatsNewDialog
            imageUrl={coverImage}
            className={styles.root}
            imageClassName={styles.image}
            title="Автозагрузка без ограничений — ваша"
            content={content}
            primaryButtonText="Хорошо"
            onClick={handleOk}
            onClose={handleClose}
            imageBgColor="var(--vkui--color_background_primary)"
            buttonTheme="vk"
            dialogSize="tiny"
            qaId="autoupload-pay-succ"
            isRebranding
            isRebrandingQuotaLanding
        />
    );
});

AutoUploadBuyDialog.displayName = 'AutoUploadBuyDialog';
